import React, {Fragment} from "react";
import { connect } from "react-redux";
import {getCurrentLayout} from "../../appLayout";
import {
  getPriceWithCurrency,
  getTotalPrice,
  toFixedPrice,
  getSlabsFeatureGroup
} from "../../../misc/helpers";
import AdvancedQuotingSubpartItems from "./advancedQuotingSubpartItems";
import {getQuoteDisplayName} from "../../../misc/quotesFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import SimilarProducts from "../similarProducts/similarProducts";
import {getCurrentQuoteRoomName, getRoomCartItemForCategoryName} from "../../../misc/categorySwitchingFunctions";
import {showWizardInsteadOfQT} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import AdvancedQuotingWizard from "./advancedQuotingWizard/advancedQuotingWizard";

const AdvancedQuotingList = (props) => {

  const {quotes, cartItems, activeQuoteIndex, showAllQuotesCartItemsList, intl, fabricatorData, wizardList,
    wizardIsActive, hideTotalPricesBeforeWSOpened} = props;
  const fabricatorSettings = fabricatorData.settings;

  return quotes.map((quote, quoteIndex) => {

    const layout = getCurrentLayout(fabricatorSettings.allowVisualizerSwitching && quote.room ? quote.room : document.kvConfig.visualizerType);

    if ((quoteIndex !== activeQuoteIndex) && !showAllQuotesCartItemsList) {
      return null
    }
    const quoteTotalPrice = getTotalPrice(quoteIndex, false);

    const otherCartItems = cartItems.filter(cartItem => {
      const isSlabsCartItem = cartItem.partId === 'slabs';
      return layout.qtCategories
        && cartItem.cartFeature
        && (cartItem.currentQuote === quoteIndex)
        && !isSlabsCartItem
        && !cartItem.bundleParentId
        && !layout.qtCategories.some(qtCat => qtCat.subParts.some(sPart => {
          return sPart.part.partId === cartItem.partId
        }))
    });

    const slabCartItems = cartItems.filter(cartItem => {
      const isSlabsCartItem = cartItem.partId === 'slabs';
      return layout.qtCategories
        && cartItem.cartFeature
        && (cartItem.currentQuote === quoteIndex)
        && !cartItem.bundleParentId
        && isSlabsCartItem
        && !layout.qtCategories.some(qtCat => qtCat.subParts.some(sPart => {
          return sPart.part.partId === cartItem.partId
        }))
    });

    const selectedQuoteRoomName = getCurrentQuoteRoomName(cartItems, quoteIndex);
    // console.log("selectedQuoteRoomName", selectedQuoteRoomName);
    const qtCategories = layout.qtCategories;
    const multiplier = quote.roomMultiplier;

    return (
      <div className={"scart-block scart-room" + (showAllQuotesCartItemsList ? " scart-room--bordered" : "")} key={quoteIndex}>
        {showAllQuotesCartItemsList ? (
          <h4 className="scart-block__title-room bold">
            <FormattedMessage id="shoppingCart.roomTitle"/>: {getQuoteDisplayName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
          </h4>
        ) : null}
        {showWizardInsteadOfQT(wizardList, wizardIsActive)
          ? <AdvancedQuotingWizard quoteIndex={quoteIndex}/>
          : layout.qtCategories ? (
          <Fragment>
            {qtCategories.map(qtCategory => {
              let currentRoomName = "";
              if (fabricatorSettings.useCategorySwitching) {
                currentRoomName = qtCategory.name.trim().toLowerCase();
                // console.log("currentRoomName", currentRoomName);
              }
              return qtCategory.subParts.map((subPart, subPartIndex) => {
                if (qtCategories.length > 1 && fabricatorSettings.useCategorySwitching
                  && ((subPart.part.partId !== "room") && (currentRoomName !== selectedQuoteRoomName))) {
                  // mb we don't need it anymore?? this is for multiple categories
                  if (getRoomCartItemForCategoryName(currentRoomName, fabricatorSettings)) { // this checks if room is available for current category
                    return null
                  }
                }
                let advancedCartItems = cartItems.filter(cartItem => {
                  if (cartItem.bundleParentId) {
                    return false
                  }
                  return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex) && (subPart.part.partId === cartItem.partId)
                      && (!cartItem.fromQtCategory || (cartItem.fromQtCategory === qtCategory.name)) // !cartItem.fromQtCategory added just in case. it should always be
                });

                return <AdvancedQuotingSubpartItems subPart={subPart}
                                                    advancedCartItems={advancedCartItems}
                                                    quoteIndex={quoteIndex}
                                                    key={quoteIndex + subPartIndex}
                                                    qtCategoryName={qtCategory.name}/>
              })
            })}
            {otherCartItems.length ? (
              <AdvancedQuotingSubpartItems subPart={{
                part: {
                  partId: "other_related_products",
                  partName: intl.formatMessage({id: "assignPopup.otherFeatureGroupName"})}
              }}
                                           advancedCartItems={otherCartItems}
                                           quoteIndex={quoteIndex}/>
            ) : null}
            {fabricatorSettings.showSlabMode ? (
              <AdvancedQuotingSubpartItems subPart={getSlabsFeatureGroup()}
                                           advancedCartItems={slabCartItems}
                                           quoteIndex={quoteIndex}/>
            ) : null}
          </Fragment>
        ) : null}
        {(showAllQuotesCartItemsList || multiplier > 1) && !hideTotalPricesBeforeWSOpened ? (
          <div className="scart-block__subtotal u-mt-075">
            <span className="scart-block__subtotal-text">
              <FormattedMessage id={multiplier > 1 ? "shoppingCart.totalColumnsRoomTotal" : "shoppingCart.totalColumnsSubTotal"}/>:
            </span>
            {getPriceWithCurrency(fabricatorSettings, toFixedPrice(quoteTotalPrice.materialPrice / (multiplier || 1)))}
          </div>
        ) : null}
        {multiplier > 1 && !hideTotalPricesBeforeWSOpened ? (
          <div className="scart-block__subtotal">
            <span className="scart-block__subtotal-text">{multiplier > 1 ? `x${multiplier}:` : ":"}</span>
            {getPriceWithCurrency(fabricatorSettings, toFixedPrice(quoteTotalPrice.materialPrice))}
          </div>
        ) : null}
        <SimilarProducts quoteIndex={+quoteIndex} />
      </div>
    )
  });
};

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive} = store.wizardState;
  const {visualizerIsChanging} = store.serverState;
  const {hideTotalPricesBeforeWSOpened} = store.cartState;
  return {
    cartItems: store.cartState.cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    quotes: store.quotesState.quotes,
    showAllQuotesCartItemsList: store.cartState.showAllQuotesCartItemsList,
    fabricatorData: store.fabricatorState,
    wizardList,
    wizardIsActive,
    visualizerIsChanging,
    hideTotalPricesBeforeWSOpened,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingList)
)
